/**
 * The size chooser: one button, cycling piccolo → normale → grande → molto grande.
 *
 * A button rather than a menu because it is pressed with a wet hand on a wall
 * screen, and because there are only four answers. It says which size is on
 * now, so nobody has to open anything to find out.
 */
import { Type } from "lucide-react";
import { KDS_SCALE_LABEL, type KdsScale } from "../lib/kds-scale";
import { useTranslation } from "../i18n";

interface KdsScaleButtonProps {
  scale: KdsScale;
  onCycle: () => void;
}

export default function KdsScaleButton({ scale, onCycle }: KdsScaleButtonProps) {
  const { t } = useTranslation();
  const label = KDS_SCALE_LABEL[scale](t);
  return (
    <button
      type="button"
      onClick={onCycle}
      className="inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-kds-muted/40 bg-kds-surface text-kds-text text-kds-action min-h-touch hover:bg-kds-card/60 transition-colors"
      title={t("kds.scale.buttonTitle", "Cambia la dimensione dei caratteri su questo monitor")}
      aria-label={t("kds.scale.buttonAria", "Dimensione caratteri: {{size}}. Tocca per cambiare.", { size: label })}
    >
      <Type size={24} strokeWidth={2.5} />
      {label}
    </button>
  );
}
